<template>
  <span class="chip">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'chip',
};
</script>

<style lang="scss" scoped>
.chip {
  display: inline-block;
  vertical-align: middle;
  font-size: 11px;
  line-height: 14px;
  font-weight: bold;
  background-color: #6972de;
  color: #fff;
  border-radius: 3px;
  padding: 10px 9px;
  cursor: default;
}
</style>
